/* WS free-delivery bars (announcement + cart drawer) + drawer housekeeping. */
(function () {
  'use strict';
  var money = function (cents) { return '\u00a3' + (cents / 100).toFixed(2).replace(/\.00$/, ''); };

  /* Announcement bar (sections/ws-announcement-shipping) */
  function renderAnnouncement(total) {
    var bar = document.querySelector('.ws-shipbar');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    var fill = bar.querySelector('.ws-shipbar__fill');
    var text = bar.querySelector('.ws-shipbar__text');
    if (!fill || !text || threshold <= 0) return;
    fill.style.width = total > 0 ? Math.min(100, Math.round((total / threshold) * 100)) + '%' : '0%';
    if (total <= 0) {
      text.textContent = (bar.dataset.textEmpty || '').replace('[threshold]', money(threshold));
    } else if (total < threshold) {
      text.textContent = (bar.dataset.textProgress || '').replace('[remaining]', money(threshold - total)).replace('[threshold]', money(threshold));
    } else {
      text.textContent = bar.dataset.textDone || '';
    }
  }

  /* Drawer bar (snippets/cart-drawer) — the gold progress is a gradient on the
     track (server-rendered inline; repainted here after cart changes). */
  function renderDrawerBar(total) {
    var bar = document.querySelector('.ws-drawer-shipbar');
    /* data-mode="mix": the drawer is showing Mix & Save, which only the
       server-rendered drawer can count (cart.js has no tags). Leave it alone. */
    if (!bar || bar.dataset.mode === 'mix') return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    var track = bar.querySelector('.ws-drawer-shipbar__track');
    var text = bar.querySelector('.ws-drawer-shipbar__text');
    if (!track || !text || threshold <= 0) return;
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var color = total >= threshold ? '#2A5240' : '#C6A664';
    track.style.background = 'linear-gradient(to right, ' + color + ' ' + pct + '%, rgba(42, 82, 64, 0.15) ' + pct + '%)';
    text.textContent = total >= threshold
      ? 'Your order qualifies for free UK delivery'
      : 'You\u2019re ' + money(threshold - total) + ' away from free UK delivery';
  }

  var refreshTimer = null;
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c && typeof c.total_price === 'number') {
            renderAnnouncement(c.total_price);
            renderDrawerBar(c.total_price);
            updateFreeShippingAttr(c.total_price);
          }
        })
        .catch(function () {});
    }, 80);
  }

  /* Single fetch intercept for cart mutations */
  var origFetch = window.fetch;

  /* Write post-discount total to a cart attribute for the free-shipping Function.
     Uses origFetch (pre-intercept) to avoid triggering another refresh loop.
     The _lastAttrPrice guard prevents redundant /cart/update.json calls. */
  var _lastAttrPrice = null;
  function updateFreeShippingAttr(totalPence) {
    if (totalPence === _lastAttrPrice) return;
    _lastAttrPrice = totalPence;
    origFetch('/cart/update.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { '_post_discount_total': String(totalPence) } })
    }).catch(function () {});
  }

  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var p = origFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (res) { if (res.ok) refresh(); }).catch(function () {});
    }
    return p;
  };

  /* Third-party widget removal inside the drawer only (belt-and-braces with
     the CSS rules in ws-cart-drawer.css). Observes just the drawer subtree. */
  var HIDE = '[class*="dealeasy" i],[id*="dealeasy" i],[class*="logbase" i],[id*="logbase" i]';
  function startObserver() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var hide = function () {
      drawer.querySelectorAll(HIDE).forEach(function (el) {
        if (el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE' && el.style.display !== 'none') {
          el.style.setProperty('display', 'none', 'important');
        }
      });
    };
    hide();
    new MutationObserver(hide).observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    startObserver();
    refresh();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* WS Judge.me brand overrides — the app injects its stylesheet after page CSS
   with double-class !important rules, so these use TRIPLED-class selectors and
   live in a <style> kept as the LAST element of <body>. */
(function () {
  'use strict';
  var css = [
    "html body .jdgm-rev-widg.jdgm-rev-widg.jdgm-rev-widg{font-family:'Plus Jakarta Sans',sans-serif!important;color:#555!important;border:0!important}",
    "html body .jdgm-rev-widg__title.jdgm-rev-widg__title.jdgm-rev-widg__title{font-family:'Newsreader',Georgia,serif!important;font-weight:500!important;font-size:2.6rem!important;letter-spacing:-.01em!important;color:#1a2420!important}",
    "html body .jdgm-rev-widg__summary-average.jdgm-rev-widg__summary-average{font-family:'Newsreader',Georgia,serif!important;font-size:3.6rem!important;color:#1a2420!important}",
    "html body .jdgm-star.jdgm-star.jdgm-star, html body .jdgm-star.jdgm--on, html body .jdgm-star.jdgm--half, html body .jdgm-prev-badge .jdgm-star{color:#c6a664!important;text-shadow:none!important}",
    "html body .jdgm-star.jdgm-star.jdgm--off{color:#e1e8dd!important}",
    "html body .jdgm-rev__author.jdgm-rev__author, html body .jdgm-rev__title.jdgm-rev__title{font-family:'Plus Jakarta Sans',sans-serif!important;color:#1a2420!important;font-weight:600!important}",
    "html body .jdgm-rev__title.jdgm-rev__title{font-size:1.4rem!important}",
    "html body .jdgm-rev__body.jdgm-rev__body{font-family:'Plus Jakarta Sans',sans-serif!important;font-size:1.3rem!important;line-height:1.6!important;color:#555!important}",
    "html body .jdgm-rev__timestamp.jdgm-rev__timestamp{font-family:'Plus Jakarta Sans',sans-serif!important;color:#999!important;font-size:1.15rem!important}",
    "html body .jdgm-rev__icon.jdgm-rev__icon{background:#e8efe4!important;color:#2a5240!important}",
    "html body .jdgm-rev__buyer-badge.jdgm-rev__buyer-badge, html body .jdgm-verified-badge.jdgm-verified-badge, html body span.jdgm-rev__buyer-badge-text{background:#f4f7f2!important;border:1px solid #dce5d6!important;color:#4a5548!important;border-radius:999px!important;font-size:1rem!important;font-weight:600!important;padding:.2rem .8rem!important}",
    "html body .jdgm-rev__buyer-badge .jdgm-ico-verified-badge{display:none!important}",
    "html body .jdgm-histogram__bar.jdgm-histogram__bar{background:#edefe8!important}",
    "html body .jdgm-histogram__bar-content.jdgm-histogram__bar-content{background:#c6a664!important}",
    "html body .jdgm-rev__replier-wrapper.jdgm-rev__replier-wrapper, html body .jdgm-rev__reply.jdgm-rev__reply{background:#f8faf6!important;border-left:3px solid #c6a664!important;border-radius:0!important;font-family:'Plus Jakarta Sans',sans-serif!important}",
    "html body .jdgm-btn--solid.jdgm-btn--solid, html body .jdgm-write-rev-link.jdgm-write-rev-link, html body .jdgm-paginate__load-more.jdgm-paginate__load-more{background:#2a5240!important;border-color:#2a5240!important;color:#fff!important;border-radius:8px!important;font-family:'Plus Jakarta Sans',sans-serif!important;letter-spacing:.05em!important;text-transform:uppercase!important;font-weight:600!important}",
    "html body .jdgm-sort-dropdown.jdgm-sort-dropdown, html body .jdgm-sort-dropdown-wrapper select{font-family:'Plus Jakarta Sans',sans-serif!important;border-color:#c1c1c1!important;border-radius:8px!important;color:#555!important}"
  ].join('\n');

  function mount() {
    var el = document.getElementById('ws-jdgm-overrides');
    if (!el) {
      el = document.createElement('style');
      el.id = 'ws-jdgm-overrides';
      el.textContent = css;
      document.body.appendChild(el);
    } else {
      el.textContent = css;
    }
    var moving = false;
    var keepLast = function () {
      if (moving) return;
      if (document.body.lastElementChild !== el) {
        moving = true;
        document.body.appendChild(el);
        setTimeout(function () { moving = false; }, 0);
      }
    };
    new MutationObserver(keepLast).observe(document.body, { childList: true });
    keepLast();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();

/* WS back-to-top button + chat-bubble handover. */
(function () {
  'use strict';
  var CHAT = [
    '#shopify-chat', '#ShopifyChat', '#ShopifyChatV2',
    '[id*="shopify-chat" i]', '[class*="shopify-chat" i]',
    'shopify-chat', 'chat-button', '#chat-button-container',
    'iframe[id*="chat-button" i]', 'iframe[id*="dummy-chat" i]',
    'iframe[title*="Shopify Inbox" i]', 'iframe[title*="chat window" i]', 'iframe[title*="chat button" i]',
    'iframe[src*="shopifycloud/inbox" i]', 'iframe[src*="shopifychat" i]'
  ];
  var CHAT_CSS = CHAT.map(function (s) { return 'html.ws-hide-chat ' + s; }).join(',') + '{display:none!important;visibility:hidden!important;pointer-events:none!important}';
  function mount() {
    var style = document.createElement('style');
    style.textContent = CHAT_CSS + '.ws-back-top{position:fixed;right:2rem;bottom:2rem;z-index:990;display:flex;align-items:center;gap:.9rem;height:5.2rem;padding:0 2.2rem;border:0;border-radius:999px;background:#2A5240;color:#fff;font:600 1.3rem/1 "Plus Jakarta Sans",sans-serif;letter-spacing:.04em;cursor:pointer;opacity:0;visibility:hidden;transform:translateY(8px);transition:opacity 200ms ease,transform 200ms ease,visibility 200ms,background 200ms ease;box-shadow:0 4px 14px rgba(26,36,32,.28)}.ws-back-top.is-visible{opacity:1;visibility:visible;transform:none}.ws-back-top:hover{background:#1D3E36}.ws-back-top svg{width:1.6rem;height:1.6rem;flex-shrink:0}@media screen and (max-width: 749px){.ws-back-top{right:1.6rem;bottom:1.6rem;height:4.8rem;padding:0 1.8rem}}';
    document.head.appendChild(style);
    var btn = document.createElement('button');
    btn.className = 'ws-back-top';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<span>Back to top</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(btn);
    var ticking = false;
    function check() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var show = false;
      if (max > 400 && window.scrollY >= 200) {
        var footer = document.querySelector('footer, .footer');
        show = footer
          ? footer.getBoundingClientRect().top < window.innerHeight
          : window.scrollY >= max * 0.75;
      }
      btn.classList.toggle('is-visible', show);
      var stickyAtcShowing = !!document.querySelector('.sticky-atc.sticky-atc--visible');
      document.documentElement.classList.toggle('ws-hide-chat', show || stickyAtcShowing);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    var stickyBar = document.querySelector('.sticky-atc');
    if (stickyBar) new MutationObserver(check).observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
